import type { ComponentChildren } from 'preact';
import { useEffect, useState } from 'preact/hooks';

interface ToastMsg {
  id: number;
  msg: string;
  kind: 'ok' | 'warn' | 'err' | 'info';
  ttl: number;
}

let nextId = 1;
const listeners = new Set<(t: ToastMsg) => void>();

export function toast(msg: string, kind: ToastMsg['kind'] = 'info', ttl = 3000): void {
  const t: ToastMsg = { id: nextId++, msg, kind, ttl };
  listeners.forEach((l) => l(t));
}

export function ToastContainer(): ComponentChildren {
  const [toasts, setToasts] = useState<ToastMsg[]>([]);

  useEffect(() => {
    const handler = (t: ToastMsg) => {
      setToasts((prev) => [...prev, t]);
      setTimeout(() => setToasts((prev) => prev.filter((x) => x.id !== t.id)), t.ttl);
    };
    listeners.add(handler);
    return () => {
      listeners.delete(handler);
    };
  }, []);

  return (
    <div class="toast-container">
      {toasts.map((t) => (
        <div key={t.id} class={`toast ${t.kind}`}>
          {t.msg}
        </div>
      ))}
    </div>
  );
}
